module.exports = __webpack_public_path__ + "img/officialaccount.32a91062.jpg";